import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#7B5B06",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 6v2.667m0 2.666h.007m-.93-8.739-5.484 9.472c-.304.525-.456.787-.433 1.003.02.188.118.359.27.47.176.128.48.128 1.087.128h10.966c.607 0 .91 0 1.086-.128a.67.67 0 0 0 .27-.47c.023-.216-.129-.478-.433-1.004l-5.483-9.47c-.303-.524-.455-.786-.652-.874a.67.67 0 0 0-.542 0c-.198.088-.35.35-.652.873"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }